import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { useEffect } from "react";
import usePaginator from "../../../../theme/Component/usePaginator";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _BagTagItem, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { Modal } from "../../../../theme/Component/Modal";
import { DropDown } from "../../../../theme/Component/DropDown";

interface Props {
    CargoManifest: any;
}

export const CargoManifestBagTagItem = ({ CargoManifest }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_BagTagItem);
    const paginador = usePaginator();

    const modal = useModal("", MODAL_md)
    const modalC = useModal("Eliminar Maleta del Manifiesto", MODAL_SM)

    useEffect(() => {
        if (CargoManifest.IDCargoManifest) {
            getLista();
        }
    }, [CargoManifest, paginador.page])

    const getLista = () => {
        const props = {
            IDCargoManifest: CargoManifest.IDCargoManifest,
            Year: _single.getCurrenYear()
        }
        instance.getBagTagItemRender(paginador.page, 15, props).then(
            (resp) => {
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;
                    data.EmployeeEntity = data.IDEmployee ? `${data.EmployeeNit} - ${data.EmployeeFullName}` : "N/P"
                });
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDBagTagItem', visible: true },
        { title: 'Codigo de Barras', property: 'BagTagCode', visible: true },
        { title: 'Empleado', property: 'EmployeeEntity', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const deleteItem = () => {
        instance.deleteBagTagItem(bean.IDBagTagItem).then(
            (resp) => {
                modalC.close()
                getLista();

            }
        ).catch(err => toast.error(err));
    }

    const create = () => {
        setBean({
            IDCargoManifest: CargoManifest.IDCargoManifest,
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Agregar Maleta al Manifiesto");
    }

    const editaItem = (obj: any) => {
        instance.updateBagTagItem(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar maleta ${bean.BagTagCode}`) } },
            { titulo: 'Eliminar Guia de Manifiesto', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    // const modalcsv = useModal("Exportar Listado", MODAL_SM)

    // const buttons = () => {
    //     return (
    //         <div className="row">
    //             <div className="col-md-12">
    //                 {_single.canExport() &&
    //                     <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
    //                 }
    //             </div>
    //         </div>
    //     )
    // }

    // const actionsDropDown = [
    //     { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
    // ];

    // const actions = (e: any) => {

    //     if (e.id === 1) {
    //         getListaExport();
    //         modalcsv.open();
    //     }
    // }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                    rowSet={setBean}
                    records={paginador}
                />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label>Codigo de Barras</label>
                            <input type="text" className="form-control" value={bean.BagTagCode} onChange={(e) => {
                                const value = e.target.value.trim();
                                setBean({ ...bean, BagTagCode: value })
                            }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.BagTagCode}</strong>
                </ModalConfirm>

            </div>
        </div>
    )
}